(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
    };
    if(!this.elements.button) return;
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a[data-value]').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  onContainerKeyUp(event){ if (event.code?.toUpperCase() !== 'ESCAPE') return; this.elements.button.focus(); }
  onItemClick(event){
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
  openSelector(){ this.elements.button.focus(); this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString()); }
  closeSelector(event){ /* noop: dropdown handled by theme */ }
}
customElements.define('localization-form', LocalizationForm);
// Back-to-top: works with document scroll OR a scroll container
(function(){
  function findScroller(){
    const picks = [
      document.scrollingElement,
      document.documentElement,
      document.body,
      document.querySelector('#MainContent'),
      document.querySelector('main'),
      document.querySelector('.page-container, .page-wrapper, .scroll-container, .content-for-layout')
    ].flat().filter(Boolean);
    for (const el of picks){
      const start = el.scrollTop;
      el.scrollTop += 1;
      if (el.scrollTop !== start){ el.scrollTop = start; return el; }
    }
    return null;
  }
  const scroller = findScroller();
  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-scroll-top]');
    if(!trigger) return;
    e.preventDefault();
    if (scroller && scroller.scrollTo){
      scroller.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0; document.body.scrollTop = 0;
    }
  }, false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-mto"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.querySelector('[data-tsc-coll]');
  if(!root) return;

  var grid   = root.querySelector('[data-tsc-grid]');
  var cards  = Array.prototype.slice.call(grid.querySelectorAll('.tsc-card'));
  var tiles  = Array.prototype.slice.call(grid.querySelectorAll('.tsc-tile'));
  var empty  = root.querySelector('[data-tsc-empty]');
  var why    = root.querySelector('[data-tsc-empty-why]');
  var countEl= root.querySelector('[data-tsc-count]');
  var chipsEl= root.querySelector('[data-tsc-chips]');
  var tray   = root.querySelector('[data-tsc-tray]');

  var state = { shape:null, base:[], band:[], price:[], cmp:[] };
  var TOTAL = cards.length;

  var LABEL = {
    storage:'Storage ottoman', adjustable:'Adjustable platform', legs:'Sits on legs',
    low:'Under 130cm', mid:'130 to 145cm', tall:'Over 145cm'
  };
  var PRICE_LABEL = { low:'Under \u00a31,200', mid:'\u00a31,200 to \u00a31,400', high:'Over \u00a31,400' };

  function matches(card){
    var d = card.dataset;
    if(state.shape && d.shape !== state.shape) return false;
    if(state.base.length){
      var ok = state.base.some(function(v){
        if(v === 'storage')    return d.storage === '1';
        if(v === 'adjustable') return d.adjustable === '1';
        if(v === 'legs')       return d.legs === '1';
        return true;
      });
      if(!ok) return false;
    }
    if(state.band.length  && state.band.indexOf(d.band) < 0) return false;
    if(state.price.length && state.price.indexOf(d.priceBand) < 0) return false;
    return true;
  }

  function apply(){
    var shown = 0;
    cards.forEach(function(c){
      var ok = matches(c);
      c.hidden = !ok;
      if(ok) shown++;
    });

    var filtering = state.shape || state.base.length || state.band.length || state.price.length;
    tiles.forEach(function(t){ t.hidden = !!filtering; });

    countEl.innerHTML = '<b>' + shown + '</b> of ' + TOTAL + ' beds';
    empty.hidden = shown !== 0;
    if(shown === 0){
      why.textContent = (state.base.indexOf('storage') > -1 || state.base.indexOf('adjustable') > -1)
        ? 'Storage and adjustable bases start at Double, and not every frame offers them. Try clearing the base filter first.'
        : 'Nothing matches every filter at once. Loosening the height or the price usually opens it up.';
    }

    // chips
    var out = [];
    if(state.shape) out.push(chip(state.shape, 'shape', state.shape));
    state.base.forEach(function(v){ out.push(chip(LABEL[v], 'base', v)); });
    state.band.forEach(function(v){ out.push(chip(LABEL[v], 'band', v)); });
    state.price.forEach(function(v){ out.push(chip(PRICE_LABEL[v], 'price', v)); });
    if(out.length) out.push('<button class="tsc-chip-clear" type="button" data-tsc-clear>Clear all</button>');
    chipsEl.innerHTML = out.join('');

    root.querySelectorAll('.tsc-ftrig').forEach(function(t){
      var g = t.dataset.panel, c = t.querySelector('.tsc-cnt');
      if(!c) return;
      var n = (state[g] || []).length;
      c.hidden = !n; c.textContent = n;
    });
    root.querySelectorAll('.tsc-silo').forEach(function(s){
      s.setAttribute('aria-pressed', String(s.dataset.shape === state.shape));
    });
  }

  function chip(label, group, value){
    return '<button class="tsc-chip" type="button" data-rm-group="' + group +
           '" data-rm-value="' + value + '">' + label + ' <span aria-hidden="true">&times;</span></button>';
  }

  function closePanels(){
    root.querySelectorAll('.tsc-fpanel').forEach(function(p){ p.classList.remove('is-open'); });
    root.querySelectorAll('.tsc-ftrig').forEach(function(t){ t.setAttribute('aria-expanded','false'); });
  }

  function recolour(hex){
    root.querySelectorAll('.tsc-card__sil path').forEach(function(p){ p.setAttribute('fill', hex); });
  }

  root.addEventListener('click', function(e){
    var t = e.target;

    var silo = t.closest('.tsc-silo');
    if(silo){ state.shape = state.shape === silo.dataset.shape ? null : silo.dataset.shape; apply(); return; }

    var trig = t.closest('.tsc-ftrig');
    if(trig){
      var panel = root.querySelector('#tscp-' + trig.dataset.panel);
      var open = panel.classList.contains('is-open');
      closePanels();
      if(!open){ panel.classList.add('is-open'); trig.setAttribute('aria-expanded','true'); }
      return;
    }
    if(!t.closest('.tsc-fpanel')) closePanels();

    var dot = t.closest('.tsc-dot');
    if(dot){
      root.querySelectorAll('.tsc-dot').forEach(function(d){ d.setAttribute('aria-pressed', String(d === dot)); });
      recolour(dot.dataset.fill);
      return;
    }

    var rm = t.closest('[data-rm-group]');
    if(rm){
      var g = rm.dataset.rmGroup, v = rm.dataset.rmValue;
      if(g === 'shape') state.shape = null;
      else {
        state[g] = state[g].filter(function(x){ return x !== v; });
        var cb = root.querySelector('input[data-group="' + g + '"][value="' + v + '"]');
        if(cb) cb.checked = false;
      }
      apply(); return;
    }

    if(t.closest('[data-tsc-clear]')){
      state.shape = null; state.base = []; state.band = []; state.price = [];
      root.querySelectorAll('.tsc-fpanel input[type=checkbox]').forEach(function(c){ c.checked = false; });
      apply(); return;
    }

    var route = t.closest('.tsc-route');
    if(route){
      if(route.dataset.routeUrl){ window.location.href = route.dataset.routeUrl; return; }
      state.shape = null; state.base = []; state.band = []; state.price = [];
      root.querySelectorAll('.tsc-fpanel input[type=checkbox]').forEach(function(c){ c.checked = false; });
      if(route.dataset.routeStorage === 'true') state.base = ['storage'];
      if(route.dataset.routeBand && route.dataset.routeBand !== 'none') state.band = [route.dataset.routeBand];
      state.base.concat(state.band).forEach(function(v){
        var cb = root.querySelector('.tsc-fpanel input[value="' + v + '"]');
        if(cb) cb.checked = true;
      });
      apply();
      root.querySelector('.tsc-filters').scrollIntoView({block:'start'});
      return;
    }

    if(t.closest('[data-tsc-tray-clear]')){
      state.cmp = [];
      root.querySelectorAll('[data-cmp]').forEach(function(c){ c.checked = false; });
      drawTray(); return;
    }
  });

  root.addEventListener('change', function(e){
    var cb = e.target;
    if(cb.dataset && cb.dataset.group){
      var g = cb.dataset.group, v = cb.value;
      if(cb.checked){ if(state[g].indexOf(v) < 0) state[g].push(v); }
      else state[g] = state[g].filter(function(x){ return x !== v; });
      apply(); return;
    }
    if(cb.dataset && cb.dataset.cmp !== undefined){
      var name = cb.dataset.cmp, url = cb.dataset.url;
      if(cb.checked){
        if(state.cmp.length >= 3){ cb.checked = false; return; }
        state.cmp.push({name:name, url:url});
      } else {
        state.cmp = state.cmp.filter(function(x){ return x.name !== name; });
      }
      drawTray();
    }
  });

  function drawTray(){
    tray.classList.toggle('is-up', state.cmp.length >= 2);
    tray.querySelector('[data-tsc-tray-items]').innerHTML =
      state.cmp.map(function(x){ return '<a href="' + x.url + '">' + x.name + '</a>'; }).join('');
  }

  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-match"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.mm');
  roots.forEach(function(root){
    if (root.dataset.mmInit) return;
    root.dataset.mmInit = '1';

    // Sleep position -> firmness memory
    var cards = root.querySelectorAll('.mm-pos-card');
    var firmEl = root.querySelector('[data-mm-firm]');
    var subEl = root.querySelector('[data-mm-sub]');
    cards.forEach(function(card){
      card.addEventListener('click', function(){
        cards.forEach(function(c){ c.classList.remove('mm-active'); });
        card.classList.add('mm-active');
        var firm = card.getAttribute('data-firm') || '';
        var whoEl = card.querySelector('h4');
        var who = whoEl ? whoEl.textContent.toLowerCase() : '';
        if (firmEl && firm) firmEl.textContent = firm + ' feels like your firmness';
        if (subEl && who) subEl.textContent = 'Based on sleeping ' + who + '. Now scroll on and pick the feel you love.';
      });
    });

    // Scroll reveal with graceful fallback
    var revealEls = root.querySelectorAll('.mm-reveal');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('mm-in'); io.unobserve(e.target); } });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add('mm-in'); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
